import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router'

import { Observable, of } from 'rxjs'
import { catchError, switchMapTo } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { RefreshSignatureData } from './user-signature.actions'

@Injectable()
export class RefreshSignatureGuard {
  constructor(private store: Store<any>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    this.store.dispatch(RefreshSignatureData())
    return of(true)
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate()
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
